import { HereLayer } from '../types';

export const getNativeMarker = (
  getIcon: HereLayer['getIcon'],
  onClick: HereLayer['onClick'],
  { data, position, iconsCache, index }: any,
  layerName: string
) => {
  const {
    url,
    height,
    width,
    anchorX,
    anchorY,
    id = ''
  } = getIcon({ data });

  const cachedIcon = iconsCache[`${id}-${index}`];
  let noiseMarker: H.map.Marker = cachedIcon;

  if (!noiseMarker) {
    const noiseIcon = new window.H.map.Icon(url, {
      size: {
        w: width / 2,
        h: height / 2
      },
      anchor: {
        x: anchorX ? anchorX / 2 : 0,
        y: anchorY ? anchorY / 2 : 0,
      }
    });

    noiseMarker = new window.H.map.Marker(position, {
      icon: noiseIcon,
      min: 0,
      volatility: true,
      data: {
        type: 'marker',
        layerName,
        data
      }
    });

    noiseMarker.addEventListener('tap', ({ target }: any) => {
      // @ts-ignore
      const { data, type } = target && target.getData ? target.getData() : {};
      if (onClick) {
        // @ts-ignore
        onClick({
          data,
          markerType: type
        });
      }
    });

    iconsCache[`${id}-${index}`] = noiseMarker;
  } else {
    noiseMarker.setGeometry(position);
    const noiseIcon = new window.H.map.Icon(url, {
      size: {
        w: width / 2,
        h: height / 2
      },
      anchor: {
        x: anchorX ? anchorX / 2 : 0,
        y: anchorY ? anchorY / 2 : 0,
      }
    });
    
    noiseMarker.setIcon(noiseIcon);
  }

  return noiseMarker;
}